import React from "react";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import PageHero from "../components/PageHero";
import PageBanner from "../components/PageBanner";
import { Users, Target, Zap, Heart } from "lucide-react";

const AboutPage = () => {
  const values = [
    { icon: Target, title: "Misyonumuz", desc: "İşletmelerin müşteri iletişimini yapay zeka ile dönüştürerek, her ölçekten şirketin 7/24 kesintisiz ve insan sıcaklığında hizmet vermesini sağlamak." },
    { icon: Zap, title: "İnovasyon", desc: "Sesli AI teknolojisinde sınırları zorluyor, Türkiye'de geliştirdiğimiz modellerle global pazarda rekabet ediyoruz." },
    { icon: Heart, title: "Müşteri Odaklılık", desc: "Her müşterimizin ihtiyacına özel çözümler üretiyor, kurulumdan canlıya geçişe kadar yanlarında oluyoruz." },
    { icon: Users, title: "Ekip", desc: "Yapay zeka, ses mühendisliği ve yazılım alanında uzman 40+ kişilik ekibimizle çalışıyoruz." },
  ];

  const hero = (
    <PageHero
      eyebrow="Hakkımızda"
      title="Sesli yapay zekanın geleceğini inşa ediyoruz"
      subtitle="Verasist, 2023'te İstanbul'da kuruldu. Bugün 500+ işletmeye sesli AI ajan çözümleri sunan, Türkiye'nin öncü voice AI platformuyuz."
    />
  );

  return (
    <PageLayout hero={hero}>
      <PageBanner src="/images/pages/team-collaboration.jpg" alt="Verasist ekibi" height="360px" />
      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-4xl mx-auto">
            <h2 className="text-[28px] font-bold mb-6" style={{ color: "var(--fg)" }}>Hikayemiz</h2>
            <div className="space-y-4 text-[15px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.88 }}>
              <p>
                Verasist, müşteri hizmetlerinde insan dokunuşunu kaybetmeden yapay zekanın gücünü kullanma vizyonuyla doğdu. Kurucu ekibimiz, geleneksel çağrı merkezlerinin yaşadığı bekleme süreleri, yüksek maliyetler ve tutarsız hizmet kalitesi sorunlarına çözüm üretmek için yola çıktı.
              </p>
              <p>
                İlk günden itibaren Türkçe başta olmak üzere 30'dan fazla dilde doğal konuşma yeteneğine sahip sesli ajanlar geliştiriyoruz. STT (Speech-to-Text), LLM (Large Language Model) ve TTS (Text-to-Speech) teknolojilerini kendi optimize ettiğimiz pipeline ile birleştirerek, sektördeki en düşük gecikme sürelerinden birini yakaladık.
              </p>
              <p>
                Bugün bankacılıktan e-ticarete, sağlıktan lojistiğe kadar 20'den fazla sektörde faaliyet gösteren işletmelere hizmet veriyoruz. NetGSM, Verimor, Twilio gibi telekom altyapılarıyla entegre çalışan platformumuz, HubSpot, Microsoft Dynamics 365, Zendesk gibi CRM ve yardım masası sistemleriyle sorunsuz entegre oluyor.
              </p>
            </div>
            <div className="mt-10 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
              <img
                src="/images/pages/modern-office.jpg"
                alt="Verasist modern ofis"
                className="w-full h-auto object-cover"
                style={{ maxHeight: "380px" }}
                loading="lazy"
              />
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-[28px] font-bold mb-10 text-center" style={{ color: "var(--fg)" }}>Değerlerimiz</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
              {values.map((v) => (
                <div
                  key={v.title}
                  className="p-6 rounded-2xl transition-colors duration-200"
                  style={{ background: "var(--card-bg)", border: "1px solid var(--border)" }}
                >
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                    <v.icon size={20} />
                  </div>
                  <h3 className="text-[16px] font-semibold mb-2" style={{ color: "var(--fg)" }}>{v.title}</h3>
                  <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--fg)", opacity: 0.82 }}>{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </SectionReveal>

      <SectionReveal>
        <section className="py-16 px-6" style={{ background: "var(--section-surface-1)" }}>
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-[28px] font-bold mb-4" style={{ color: "var(--fg)" }}>Birlikte çalışalım</h2>
            <p className="text-[15px] mb-8" style={{ color: "var(--fg)", opacity: 0.85 }}>
              Sesli AI teknolojisiyle işletmenizi bir adım öteye taşımak ister misiniz? Ekibimizle tanışın, size özel çözümü birlikte tasarlayalım.
            </p>
            <a
              href="https://app.verasist.ai"
              className="inline-block px-8 py-3 rounded-full font-semibold text-[14px] transition-all duration-200"
              style={{ background: "var(--brand-navy)", color: "#fff" }}
            >
              Hemen Başla
            </a>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default AboutPage;
